import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback
} from "react";
import { Typography, Grid, Paper, Button } from "@material-ui/core";
import useStyles from "../styles/deviceStyle";
import DeviceGroupManagementBtnList from "../components/device/DeviceGroupManagementBtnList";
import VncMultipleUsersLinkBtn from "../components/device/VncMultipleUsersLinkBtn";
import DeviceDetailBasicData from "../components/device/DeviceDetailBasicData";
import DeviceDetailGraphs from "../components/device/DeviceDetailGraphs";
import DeviceDetailTaskHistory from "../components/device/DeviceDetailTaskHistory";
import { useTranslation } from "../langs/useTranslation";
import {
  getSystemInfoAPI,
  getHardwareInfoAPI,
  getNetworkInfoAPI
} from "../apis/getDeviceInfoAPI";
import { Link, useHistory, useParams } from "react-router-dom";
import * as dayjs from "dayjs";
import * as localforage from "localforage";
import LoadingIndicator from "../components/commons/LoadingIndicator";
import VncFailedDialog from "../components/device/VncFailedDialog";
import { getDeviceDetailAPI } from "../apis/getDeviceDetailAPI";
import useStateOnMounted from "../helpers/useStateOnMounted";
import { timeDiff } from "../helpers/datetimeHandlers";
import {
  setUpVncLinkAndExpiration,
  callVncAPI,
  vncConnectionFailed
} from "../helpers/vncLinkHandler";
import { BreadCrumbs } from "../components/device/BreadCrumbs";
import { SubmitBtnContext } from "../App";
import DeviceBtnSets from "../components/device/DeviceBtnSets";
import ScreenShot from "../components/device/ScreenShot";
import { DeviceAlarmListDatatable } from "@/helpers/DeviceAlarmListDatatable";
import { DeviceScheduledListDatatable } from "@/helpers/DeviceScheduledListDatatable";
import HasPermission from "@/components/commons/HasPermission";
import { useGlobalState } from "@/GlobalProvider";
import { useUpdateEffect } from "ahooks";
import { getDeviceTwinsApi } from "@/apis/deviceDetailAPI";
import { PrintInfoTable } from "@/components/device/PrintInfoTable";
import ProfileDeployStatus from "@/components/device/ProfileDeployStatus";
import { AutorenewRounded } from "@material-ui/icons";
import Modal from "@/components/Modal";
import ContentDisplayStatus from "@/components/device/ContentDisplayStatus";
import { APP_ENV } from "@/APP_ENV";

export const VNCContext = React.createContext({});

const DeviceDetail = () => {
  const { t } = useTranslation("device");
  const classes = useStyles();
  const { device_id } = useParams();
  const { dispatch } = useContext(SubmitBtnContext);
  const [VNCLink, setVNCLink] = useStateOnMounted("");
  const [deviceData, setDeviceData] = useStateOnMounted();
  const [reportedTwins, setReportedTwins] = useStateOnMounted();
  const [twinsData, setTwinsData] = useStateOnMounted();
  const [hardware, setHardware] = useStateOnMounted("");
  const [network, setNetwork] = useStateOnMounted("");
  const [system, setSystem] = useStateOnMounted("");
  const [isLoading, setIsLoadingFuc] = useState(false);
  const [closeDialog, setCloseDialog] = useState(true);
  const refreshCMSStatusRef = useRef(null)
  const setIsLoading = loading => {
    setIsLoadingFuc(loading)
    if (loading) setCloseDialog(false)
  }

  const [open, setOpen] = useState(false);
  const [VNCExpiredDate, setVNCExpiredDate] = useStateOnMounted();
  const [openDeviceBtnSets, setOpenDeviceBtnSets] = useState(false);
  const [onlineStatus, setOnlineStatus] = useState("");
  const [dialogContent, setDialogContent] = useState("");
  const [osType, setOsType] = useStateOnMounted("");
  // const [hasVncFromAPI, setHasVncFromAPI] = useStateOnMounted(false);
  const [openResendDialog, setOpenResendDialog] = useState(false);
  const [taskId, setTaskId] = useState();
  const [taskName, setTaskName] = useState();
  const [loading, setLoading] = useStateOnMounted(true);
  const [cmsLoading, setCMSLoading] = useStateOnMounted(false);
  const [taskStatus, setTaskStatus] = useStateOnMounted("");
  const [taskStatusPolling, setTaskStatusPolling] = useState(0);
  const { currentCompanyId } = useGlobalState();
  const history = useHistory();
  let timer = useRef(null);
  const taskHistoryRef = useRef(null);
  const printInfoTableRef = useRef(null);

  const getDeviceDetail = useCallback(
    async isRefresh => {
      try {
        if (!isRefresh) {
          setLoading(true);
        }
        const data = await getDeviceDetailAPI(device_id);
        if (data && data.device) {
          await localforage.setItem(`${device_id}`, data.device);
          setDeviceData(data.device);
          setOnlineStatus(data.device.online_offline_status);
          setOsType(
            data.device.os_type?.replace(/^[a-z]/, m => m.toUpperCase())
          );
          // setHasVncFromAPI(data.device.remote_assistance_request);
        }
        if (!isRefresh) {
          const twinsDataRes = await getDeviceTwinsApi(device_id);
          if (twinsDataRes.data) {
            setReportedTwins(twinsDataRes.data.properties.reported);
            setTwinsData(twinsDataRes.data.properties);
          }
        }
      } finally {
        if (!isRefresh) {
          setLoading(false);
        }
      }
    },
    [device_id]
  );

  const serialNumber = deviceData?.serial_number ?? "";
  const nubisVersion = deviceData?.nubis_version ?? "";

  const handleSetVNC = useCallback(() => {
    console.log("nubisVersion: ", nubisVersion, "onlineStatus: ", onlineStatus);
    if (
      (nubisVersion === "nubis_free" || nubisVersion === "nubis_pro") &&
      onlineStatus === "online"
    ) {
      setIsLoading(false);
      setTaskStatus("");
      callVncAPI(
        device_id,
        deviceData,
        nubisVersion,
        setIsLoading,
        setVNCLink,
        setVNCExpiredDate,
        setDialogContent,
        handleVNCFailedDialogOpen,
        t,
        "deviceDetail",
        setTaskStatus
      );
    }
    if (onlineStatus === "offline" || !nubisVersion) {
      let failedText = `${t("tasks.vncDeviceInvalidToConnectVNC")}`;
      vncConnectionFailed(
        setIsLoading,
        handleVNCFailedDialogOpen,
        setDialogContent,
        failedText
      );
    }
  }, [deviceData, onlineStatus]);

  const checkIfVNCExistAlready = useCallback(async () => {
    // check if remote vnc link exsits
    // let detailData = await localforage.getItem(device_id);
    let ifVNCFromAPIExists = deviceData
      ? deviceData.remote_assistance_request
      : false;
    let vncExpiredDateStringFromAPI =
      ifVNCFromAPIExists && ifVNCFromAPIExists.expired_at_format;

    // check if local vnc link exsits
    let localforageVNC = await localforage.getItem(`${device_id}VNC`);

    let vncExpiredDateStringFormLocal =
      localforageVNC && localforageVNC.vnc && localforageVNC.vnc.expired_at;

    if (deviceData) {
      if (ifVNCFromAPIExists && localforageVNC) {
        let showVncFromAPI = timeDiff(
          vncExpiredDateStringFromAPI,
          vncExpiredDateStringFormLocal,
          false
        );
        if (showVncFromAPI) {
          setUpVncLinkAndExpiration(
            vncExpiredDateStringFromAPI,
            ifVNCFromAPIExists,
            setVNCLink,
            setVNCExpiredDate,
            deviceData
          );
        } else {
          let timeValid = setUpVncLinkAndExpiration(
            vncExpiredDateStringFormLocal,
            localforageVNC.vnc.server,
            setVNCLink,
            setVNCExpiredDate,
            deviceData
          );
          if (!timeValid) {
            await localforage.removeItem(`${device_id}VNC`);
          }
        }
      }

      if (ifVNCFromAPIExists && !localforageVNC) {
        setUpVncLinkAndExpiration(
          vncExpiredDateStringFromAPI,
          ifVNCFromAPIExists,
          setVNCLink,
          setVNCExpiredDate,
          deviceData
        );
      }

      if (!ifVNCFromAPIExists && localforageVNC) {
        let timeValid = setUpVncLinkAndExpiration(
          vncExpiredDateStringFormLocal,
          localforageVNC.vnc.server,
          setVNCLink,
          setVNCExpiredDate,
          deviceData
        );
        if (!timeValid) {
          await localforage.removeItem(`${device_id}VNC`);
        }
      }
    }
  }, [device_id, deviceData, setVNCExpiredDate, setVNCLink]);

  const handleVNCFailedDialogOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleVNCFailedDialogClose = useCallback(async () => {
    await localforage.removeItem(`${device_id}VNC`);
    setOpen(false);
    setVNCLink();
    setVNCExpiredDate();
  }, []);

  const handleClickVNCUserLink = useCallback(e => {
    //check if the link is expired
    //since the state 'VNCExpiredDate' using here is local time zone,
    //current date should be the local time zone
    const currentDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
    const expiredDateForDiff = dayjs(VNCExpiredDate);
    const currentDateForDiff = dayjs(currentDate);
    const timeDiff = expiredDateForDiff.diff(currentDateForDiff);
    if (timeDiff > 0) {
      setVNCLink(VNCLink);
    } else {
      e.preventDefault();
      handleVNCFailedDialogOpen();
      setDialogContent(`${t("tasks.vncConnectionFailed")}`);
    }
  }, [VNCLink]);

  const handleOpenDeviceBtnSets = useCallback(
    () => setOpenDeviceBtnSets(true),
    []
  );

  const hardwareDataFetch = async () => {
    let data = await getHardwareInfoAPI(device_id);
    setHardware(data);
  };

  const networkDataFetch = async () => {
    let data = await getNetworkInfoAPI(device_id);
    setNetwork(data);
  };

  const systemDataFetch = async () => {
    let data = await getSystemInfoAPI(device_id);
    setSystem(data);
  };

  const handleResendDialogOpen = (task_id, task_name) => {
    setOpenResendDialog(true);
    setTaskId(task_id);
    setTaskName(task_name);
    dispatch({ type: "stopLoading" });
  };

  const handleResendDialogClose = () => setOpenResendDialog(false);

  const handleReloadTaskHistory = useCallback(
    () => taskHistoryRef.current.reload(),
    []
  );

  // store four device info into localforage
  useEffect(() => {
    getDeviceDetail(false);
    hardwareDataFetch();
    networkDataFetch();
    systemDataFetch();

    const intervalId = setInterval(() => {
      getDeviceDetail(true);
    }, 2 * 60 * 1000);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);

  useEffect(() => {
    checkIfVNCExistAlready();
  }, [checkIfVNCExistAlready]);

  useUpdateEffect(() => {
    history.replace("/");
  }, [currentCompanyId]);

  useEffect(() => {
    if (isLoading) {
      timer.current = setInterval(() => {
        setTaskStatusPolling(prev => ++prev);
      }, 1000);
    } else {
      if (timer.current) {
        clearInterval(timer.current);
      }
      setTaskStatus("");
      setTaskStatusPolling(0);
    }
  }, [isLoading]);

  return (
    <div className={classes.root}>
      <BreadCrumbs
        showDeviceList={true}
        pageName={serialNumber}
        noTranslate={true}
      />
      <Grid container spacing={3}>
        {/* Side btn */}
        <Grid
          item
          xs={12}
          sm={2}
          md={2}
          lg={2}
          xl={2}
          className={classes.groupBtnsWrapper}
        >
          <Paper elevation={0} className={classes.singleDeviceTaskBtnListWrap}>
            <DeviceGroupManagementBtnList
              reloadTaskHistory={handleReloadTaskHistory}
              getDeviceDetail={getDeviceDetail}
              deviceData={deviceData}
              onClickSetVNC={handleSetVNC}
              onlineStatus={onlineStatus}
              VNCLink={VNCLink}
              nubisVersion={nubisVersion}
              serialNumber={serialNumber}
            />
          </Paper>
        </Grid>
        {/* Main detail */}
        <Grid item xs={12} sm={10} md={10} lg={10} xl={10}>
          {nubisVersion === "nubis_pro" ? (
            <VncMultipleUsersLinkBtn
              VNCLink={VNCLink}
              VNCExpiredDate={VNCExpiredDate}
              handleClickVNCUserLink={handleClickVNCUserLink}
              deviceId={device_id}
            />
          ) : (
            ""
          )}
          {/* Information */}
          <DeviceDetailBasicData
            loading={loading}
            deviceId={device_id}
            system={system}
            hardware={hardware}
            deviceData={deviceData}
            reportedTwins={reportedTwins}
            twinsData={twinsData}
            osType={osType}
            openMore={handleOpenDeviceBtnSets}
            onlineStatus={onlineStatus}
            setDeviceData={setDeviceData}
          />
          {/* click more btn dialog */}
          <DeviceBtnSets
            open={openDeviceBtnSets}
            setOpen={setOpenDeviceBtnSets}
            hardware={hardware}
            system={system}
            network={network}
          />
          {/* operation */}
          <DeviceDetailGraphs
            getDeviceDetail={getDeviceDetail}
            hardware={hardware}
            onlineStatus={onlineStatus}
            deviceData={deviceData}
            loading={loading}
          />
          {osType === "Windows" && (
            <Paper elevation={0} className={`${classes.tableMoveTopReset}`} style={{ marginBottom: 16 }}>
              <PrintInfoTable ref={printInfoTableRef} device_id={device_id} />
            </Paper>
          )}
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} lg={5} xl={4}>
              {/* screenshot */}
              <ScreenShot t={t} device_id={device_id} deviceData={deviceData} />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={7} xl={8}>
              {/* task history */}
              <Paper
                elevation={0}
                className={`${classes.tableMoveTopReset}`}
                style={{ height: "100%" }}
              >
                <DeviceDetailTaskHistory
                  ref={taskHistoryRef}
                  deviceData={deviceData}
                  setOpenResendDialog={setOpenResendDialog}
                  dispatch={dispatch}
                  openResendDialog={openResendDialog}
                  taskId={taskId}
                  taskName={taskName}
                  device_id={device_id}
                  handleResendDialogClose={handleResendDialogClose}
                  handleResendDialogOpen={handleResendDialogOpen}
                  nubisVersion={nubisVersion}
                  setOnlineStatus={setOnlineStatus}
                />
              </Paper>
            </Grid>
          </Grid>
          <HasPermission permission="device_detail_alarm_info">
            <Grid container spacing={4}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Paper elevation={0}>
                  <Typography variant="h5" style={{ marginBottom: 16 }}>
                    {t({ defaultMessage: "报警通知" })}
                  </Typography>
                  <DeviceAlarmListDatatable deviceId={device_id} />
                </Paper>
              </Grid>
            </Grid>
          </HasPermission>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Paper elevation={0}>
                <Typography
                  variant="h5"
                  component="span"
                  style={{ marginBottom: 16 }}
                >
                  {t({ defaultMessage: "排程执行" })}
                </Typography>
                <Link
                  to={`/schedule/calendar/${deviceData?.serial_number ?? ""}`}
                  style={{
                    marginBottom: 8,
                    marginLeft: 5,
                    display: "inline-block",
                    verticalAlign: "middle"
                  }}
                >
                  <Button variant="outlined" color="primary" size="small">
                    {t({ defaultMessage: "查看排程日历" })}
                  </Button>
                </Link>
                <DeviceScheduledListDatatable deviceId={device_id} />
              </Paper>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Paper elevation={0}>
                <Typography
                  variant="h5"
                  component="span"
                  style={{
                    marginBottom: 16,
                    display: "flex",
                    alignItems: "center"
                  }}
                >
                  {t({ defaultMessage: "配置文件部署状态" })}
                  <AutorenewRounded
                    size="small"
                    style={{
                      marginLeft: 8,
                      cursor: "pointer",
                      animation: loading ? "spin 1s linear infinite" : ""
                    }}
                    onClick={() => getDeviceDetail(false)}
                  />
                </Typography>
                <ProfileDeployStatus
                  deviceData={deviceData}
                  twinsData={twinsData}
                />
              </Paper>
            </Grid>
          </Grid>
          {APP_ENV.REACT_APP_CMS_ENABLED && (
            <Grid container spacing={4}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Paper elevation={0}>
                  <Typography
                    variant="h5"
                    component="span"
                    style={{
                      marginBottom: 16,
                      display: "flex",
                      alignItems: "center"
                    }}
                  >
                    {t({ defaultMessage: "内容展示" })}
                    <AutorenewRounded
                      size="small"
                      style={{
                        marginLeft: 8,
                        cursor: "pointer",
                        animation: cmsLoading ? "spin 1s linear infinite" : ""
                      }}
                      onClick={() => {
                        if (refreshCMSStatusRef.current) {
                          setCMSLoading(true)
                          refreshCMSStatusRef.current().then(() => {
                            setCMSLoading(false)
                          })
                        }
                      }}
                    />
                  </Typography>
                  <ContentDisplayStatus
                    companyId={deviceData?.companies[0].id}
                    deviceId={device_id}
                    refreshRef={refreshCMSStatusRef}
                    loading={cmsLoading}
                  />
                </Paper>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
      <VncFailedDialog
        open={open}
        onClose={handleVNCFailedDialogClose}
        dialogContent={dialogContent}
      />
      <Modal
        open={!closeDialog && isLoading}
        showConfirm={false}
        showCancel={false}
        onClose={() => setCloseDialog(true)}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
          <Typography variant="h6" color="secondary">
            {t("tasks.connectingToDevice")}
            <span style={{ marginLeft: 10 }}>
              {taskStatus}（{taskStatusPolling}s）
            </span>
          </Typography>
          <Typography variant="caption" color="secondary">
            {t("tasks.noticeThePopoutWindowBlocker")}
          </Typography>
          <Typography variant="caption" color="secondary">
            {t("tasks.waitVncConnectionTime")}
          </Typography>
          <LoadingIndicator />
        </div>
      </Modal>

    </div>
  );
};

export default DeviceDetail;
